export default __webpack_public_path__ + "static/OperatorMono-MediumItalic-b12cbf7446491f4942a10446c00ef6e6.woff2";